import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { ErrorState } from '@/components/ui';

/** Erro de rota. Distingue 404 de falha real para não assustar à toa. */
export function RouteError(): React.ReactElement {
  const error = useRouteError();
  const navigate = useNavigate();

  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-safe">
      <ErrorState
        title={notFound ? 'Página não encontrada' : 'Não foi possível abrir esta tela'}
        description={
          notFound
            ? 'O endereço acessado não existe na aplicação.'
            : 'Seus dados offline não foram afetados.'
        }
        onRetry={() => void navigate('/', { replace: true })}
      />
    </div>
  );
}
